<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">
    Invoice
    <span *ngIf="invoice?.invoiceNumber"> - {{invoice.invoiceNumber}}</span>
    <span *ngIf="invoice?.klyantInvoiceId" class="text-success ms-2">- SENT TO KLYANT</span>
    <span *ngIf="invoice?.sentToKlyantDate"> - {{invoice.sentToKlyantDate | date:'dd/MM/yyyy HH:mm'}}</span>
  </h5>
  <div class="d-flex align-items-center gap-2  ms-auto">
    <button *ngIf="!readOnly" type="button" class="btn btn-outline-success btn-sm" (click)="refreshAutoLines()">
      <fa-icon [icon]="faSync"></fa-icon> Pull Invoice Items
    </button>
    <button type="button" class="btn btn-outline-success btn-sm" (click)="openAddInvoice()">
      <fa-icon [icon]="faPlus"></fa-icon> Additional Invoice
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
</div>

<div class="modal-body" style="min-width: 1100px; overflow-x: auto;">

  <!-- Loading spinner -->
  <div *ngIf="!invoice || creatingInvoice || refreshingData" class="d-flex justify-content-center py-4">
    <div class="spinner-border text-success" style="width: 4rem; height: 4rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="invoice && !creatingInvoice && !refreshingData" class="row g-2">

     <!-- Professional Charges -->
    <div class="col-3">
      <div class="d-flex align-items-center justify-content-between mb-1" style="height: 32px;">
        <h6 class="fw-bold mb-0">{{columnTitles[0]}}</h6>
        <button *ngIf="!readOnly" type="button" class="btn btn-sm p-1" (click)="addInvoiceItem(1)">
          <fa-icon [icon]="faPlus"></fa-icon>
        </button>
      </div>
      <div class="border rounded overflow-auto mb-1" style="height: 350px;">
        <div *ngFor="let ii of professionalCharges"
             class="d-flex align-items-center border-bottom px-2 py-1 small invoice-list-item">
          <div class="flex-grow-1 pe-1">{{ii.description}}</div>
          <div style="width: 70px;">{{ii.net | currency:'£'}}</div>
          <div style="width: 60px;">{{ii.vat | currency:'£'}}</div>
          <div *ngIf="!readOnly" class="d-flex gap-1">
            <fa-icon [icon]="faTimes" class="text-danger" style="cursor:pointer;" (click)="removeInvoiceItem(ii.id)"></fa-icon>
            <fa-icon [icon]="faPencil" class="text-success" style="cursor:pointer;" (click)="editInvoiceItem(ii)"></fa-icon>
          </div>
        </div>
      </div>
      <div class="d-flex border rounded px-2 py-1 small fw-bold bg-light">
        <div class="flex-grow-1">Total:</div>
        <div style="width: 70px;">{{professionalChargesTotal | currency:'£'}}</div>
        <div style="width: 60px;">{{professionalChargesVatTotal | currency:'£'}}</div>
      </div>
    </div>

    <!-- Disbursements -->
    <div class="col-3">
      <div class="d-flex align-items-center justify-content-between mb-1" style="height: 32px;">
        <h6 class="fw-bold mb-0">{{columnTitles[1]}}</h6>
      </div>
      <div class="border rounded overflow-auto mb-1" style="height: 350px;">
        <div *ngFor="let ii of disbursements"
             class="d-flex align-items-center border-bottom px-2 py-1 small invoice-list-item"
             [ngClass]="{'bg-danger bg-opacity-25': ii.klyantOutlayId == null}">
          <div class="flex-grow-1 pe-1">{{ii.description}}</div>
          <div style="width: 70px;">{{ii.net | currency:'£'}}</div>
          <div style="width: 60px;">{{ii.vat | currency:'£'}}</div>
        </div>
      </div>
      <div class="d-flex border rounded px-2 py-1 small fw-bold bg-light">
        <div class="flex-grow-1">Total:</div>
        <div style="width: 70px;">{{disbursementsTotal | currency:'£'}}</div>
        <div style="width: 60px;">{{disbursementsVatTotal | currency:'£'}}</div>
      </div>
    </div>

     <!-- Additional Charges -->
    <div class="col-3">
      <div class="d-flex align-items-center justify-content-between mb-1" style="height: 32px;">
        <h6 class="fw-bold mb-0">{{columnTitles[2]}}</h6>
        <div class="d-flex gap-1" *ngIf="!readOnly">
          <button type="button" class="btn btn-sm p-1" (click)="openInvoiceUploader()">
            <fa-icon [icon]="faUpload"></fa-icon>
          </button>
          <button type="button" class="btn btn-sm p-1" (click)="addInvoiceItem(3)">
            <fa-icon [icon]="faPlus"></fa-icon>
          </button>
        </div>
      </div>
      <div class="border rounded overflow-auto mb-1" style="height: 350px;">
        <div *ngFor="let ii of additionalCharges"
             class="d-flex align-items-center border-bottom px-2 py-1 small invoice-list-item">
          <div class="flex-grow-1 pe-1">{{ii.description}}</div>
          <div style="width: 70px;">{{ii.net | currency:'£'}}</div>
          <div style="width: 60px;">{{ii.vat | currency:'£'}}</div>
          <div *ngIf="!readOnly" class="d-flex gap-1">
            <fa-icon [icon]="faTimes" class="text-danger" style="cursor:pointer;" (click)="removeInvoiceItem(ii.id)"></fa-icon>
            <fa-icon [icon]="faPencil" class="text-success" style="cursor:pointer;" (click)="editInvoiceItem(ii)"></fa-icon>
          </div>
        </div>
      </div>
      <div class="d-flex border rounded px-2 py-1 small fw-bold bg-light">
        <div class="flex-grow-1">Total:</div>
        <div style="width: 70px;">{{additionalChargesTotal | currency:'£'}}</div>
        <div style="width: 60px;">{{additionalChargesVatTotal | currency:'£'}}</div>
      </div>
    </div>

    <!-- Third Party Fees -->
    <div class="col-3">
      <div class="d-flex align-items-center justify-content-between mb-1" style="height: 32px;">
        <h6 class="fw-bold mb-0">{{columnTitles[3]}}</h6>
        <button type="button" class="btn btn-sm p-1" (click)="addInvoiceItem(4)">
          <fa-icon [icon]="faPlus"></fa-icon>
        </button>
      </div>
      <div class="border rounded overflow-auto mb-1" style="height: 350px;">
        <div *ngFor="let ii of thirdPartyFees"
             class="d-flex align-items-center border-bottom px-2 py-1 small invoice-list-item">
          <div class="flex-grow-1 pe-1">{{ii.description}}</div>
          <div style="width: 70px;">{{ii.net | currency:'£'}}</div>
          <div style="width: 60px;">{{ii.vat | currency:'£'}}</div>
          <div class="d-flex gap-1">
            <fa-icon [icon]="faTimes" class="text-danger" style="cursor:pointer;" (click)="removeInvoiceItem(ii.id)"></fa-icon>
            <fa-icon [icon]="faPencil" class="text-success" style="cursor:pointer;" (click)="editInvoiceItem(ii)"></fa-icon>
          </div>
        </div>
      </div>
      <div class="d-flex border rounded px-2 py-1 small fw-bold bg-light">
        <div class="flex-grow-1">Total:</div>
        <div style="width: 70px;">{{thirdPartyFeesTotal | currency:'£'}}</div>
        <div style="width: 60px;">{{thirdPartyFeesVatTotal | currency:'£'}}</div>
      </div>
    </div>
  </div>


</div>

<div class="modal-footer" *ngIf="invoice">
  <div *ngIf="hasError" class="text-danger me-auto">{{errorMessage}}</div>

  <ng-container *ngIf="caseTypeId == 1 || caseTypeId == 6 || caseTypeId == 7 || caseTypeId == 8">
    <button *ngIf="!isGeneratingCompletionStatement" type="button" class="btn btn-outline-success"
      [disabled]="professionalCharges.length == 0 && additionalCharges.length == 0 && disbursements.length == 0 && thirdPartyFees.length == 0"
      (click)="generateCompletionStatement()">Completion Statement</button>
    <button *ngIf="isGeneratingCompletionStatement" type="button" class="btn btn-outline-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Generating...
    </button>
  </ng-container>

  <button type="button" class="btn btn-outline-success"
    [disabled]="disableGenerateInvoice() || creatingInvoice"
    (click)="generateInvoice()">
    <span *ngIf="!invoice.invoiceNumber">Generate Invoice</span>
    <span *ngIf="invoice.invoiceNumber">Re-Print Invoice</span>
  </button>

  <ng-container *ngIf="!invoice.klyantInvoiceId">
    <button *ngIf="!sendingToKlyant" type="button" class="btn btn-secondary"
      [disabled]="!invoice.invoiceNumber"
      (click)="sendToKlyant()">Send To Klyant</button>
    <button *ngIf="sendingToKlyant" type="button" class="btn btn-secondary" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Sending...
    </button>
  </ng-container>
</div>

